import { t } from '../i18n/runtime';
/**
 * Bottom tab bar — used by G1 Home, P1 Calendar, P5 Leaderboard, P2 Profile.
 *
 * Pure DOM; no framework. Pass current tab id + a navigate callback.
 */
import { type IconName, iconString } from './icons';

// IA (2026-06): Practice is promoted to a permanent tab — it is the play-more /
// progression home. Leaderboard is demoted off the bar; the country season is
// reached by tapping the country-rank line on Home + the "Country rank" row in
// Profile. Four austere tabs, no fifth slot.
const TABS: Array<{ id: string; route: string; icon: IconName; labelKey: string }> = [
  { id: 'home', route: '/', icon: 'home', labelKey: 'nav.home' },
  { id: 'practice', route: '/practice', icon: 'practice', labelKey: 'nav.practice' },
  { id: 'calendar', route: '/calendar', icon: 'calendar', labelKey: 'nav.calendar' },
  { id: 'profile', route: '/profile', icon: 'profile', labelKey: 'nav.profile' },
];

export function tabbar(activeId: string, onNavigate: (route: string) => void): HTMLElement {
  const nav = document.createElement('nav');
  nav.className = 'tabbar';
  nav.setAttribute('aria-label', 'Primary');
  nav.innerHTML = TABS.map(
    (tab) => `
    <button class="tab ${tab.id === activeId ? 'is-active' : ''}" data-route="${tab.route}" ${tab.id === activeId ? 'aria-current="page"' : ''}>
      <span class="tab-icon" aria-hidden="true">${iconString(tab.icon, 22)}</span>
      <span class="tab-label">${t(tab.labelKey)}</span>
    </button>
  `,
  ).join('');
  nav.addEventListener('click', (ev) => {
    const btn = (ev.target as HTMLElement | null)?.closest('.tab') as HTMLElement | null;
    if (!btn) return;
    const route = btn.getAttribute('data-route');
    if (route) onNavigate(route);
  });
  return nav;
}

export const TAB_IDS = TABS.map((t) => t.id);
